import React, { useEffect, useState } from 'react';
import { CalendarClock } from 'lucide-react';

import { RewardsHistoryItem } from '../../../../utils/types';
import { formatToLocalDate } from '../../../../utils/utils';

import { getRewardsHistory } from '../../../../../auth/_requests';
import { useAuth } from '../../../../../auth/Auth';

const ASSET_TYPES = {
  POINTS: 'points',
  TICKETS: 'tickets',
} as const;

const HistoryTab: React.FC = () => {
  const { auth } = useAuth();
  const [history, setHistory] = useState<RewardsHistoryItem[]>([]);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        // setLoading(true);
        const response = await getRewardsHistory(auth?.data.token);
        setHistory(response.data);
      } catch (error) {
        console.error('Error fetching offers:', error);
      } finally {
        // setLoading(false);
      }
    };
    fetchHistory();
  }, []);
  const sentenceCase = (text: string = ''): string => {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  return (
    <div className='w-full'>
      <div className='space-y-4 w-full'>
        {history.map((item) => (
          <div key={item.pointTransactionId} className='w-full'>
            <div className='p-6 rounded-[20px] border border-[#DEE2EF] bg-[linear-gradient(229deg,_#FFF_-13.57%,_#F2F4F9_113.63%)] w-full'>
              <div className='flex flex-col gap-2 xxs:flex-row items-start xxs:justify-between xxs:items-center w-full'>
                <div className='flex flex-col gap-1 xxs:max-w-[60%] w-full'>
                  {' '}
                  {/* Limit width so truncate works */}
                  <span className='text-main text-base font-semibold break-words'>
                    {item.pointRewardTypeDescription
                      ? item.pointRewardTypeDescription
                      : sentenceCase(item.pointTaskDescription || '')}
                  </span>
                  <span className='text-light/70 text-sm'>
                    {formatToLocalDate(item.timestampAdded)}
                  </span>
                </div>
                <span
                  className={`text-base font-bold ${
                    item.transactionType === 'credit' ? 'text-success' : 'text-failure'
                  }`}
                >
                  {item.transactionType === 'debit' ? '-' : '+'}
                  {Number(item.amount ?? 0).toLocaleString('en-US')}{' '}
                  {item.assetType === ASSET_TYPES.TICKETS
                    ? 'tickets'
                    : item.assetType === ASSET_TYPES.POINTS
                      ? 'pts'
                      : ''}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {history.length === 0 && (
        <div className='bg-gray-50 rounded-xl p-8 text-center'>
          <CalendarClock className='h-12 w-12 mx-auto text-gray-400' />
          <h3 className='mt-4 text-lg font-medium text-gray-900'>No redemption history</h3>
          <p className='mt-1 text-sm text-gray-500'>
            You haven't redeemed any rewards yet. Check out the available offers!
          </p>
        </div>
      )}
    </div>
  );
};

export default HistoryTab;
